var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({class:_vm.$style.banner,style:(_vm.computedSpacingStyles)},'div',{ id: _vm.id },false),[_c('img',_vm._b({class:_vm.$style['banner-img'],attrs:{"src":_vm.computedSrc}},'img',{ height: _vm.height, width: _vm.width },false))])}
var staticRenderFns = []

export { render, staticRenderFns }